import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const {
  breakpoints: { BreakpointNames },
} = constants;
const {
  colors: { ui },
} = constants;

const greyDark = ui.neutral[700];
const white = ui.white[700];

export const buttonWithPopOutMenuCss = (isMediumSize: boolean) => ({
  root: {
    width: "100%",
  },
  Button: {
    root: {
      border: `1px solid ${greyDark}`,
      color: greyDark,
      justifyContent: "space-between",
      padding: "16px",
      width: "100%",
      backgroundColor: white,

      ...(isMediumSize && {
        "span:first-of-type": {
          span: {
            width: "120px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "left",
          },
        },

        "span:nth-of-type(2)": {
          width: "20px",
        },
      }),
    },
  },
  PopOut: {
    popOutContents: {
      minWidth: "100%",
      maxHeight: "50vh",
      overflowY: "auto",
      padding: "8px",
      zIndex: 100,
      marginLeft: "16px",
      [breakpoint.upTo(BreakpointNames.sm)]: {
        marginRight: "16px",
      },
    },
  },
});
